module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RenewalQueryView.js"));
	}, "RenewalQueryView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RenewalQueryView!./src/pages/Promote/Achievement/RenewalQuery/RenewalQueryView.js
// module id = 1665
// module chunks = 418